const initialState = {
    levelFourDropDownList: [],
    isFetchingLevelFourDropDown: false,
    isAddingLevelFour: false,
    isFetchingAccountType: false,
    accountTypeList: [],
    isUploadingLevelFour: false,
    uploadlevelFour: [],
    levelFourViewData: [],
    isFetchingLevelFourViewData: false,
};

const LevelFourReducer = (state = initialState, action) => {
    switch (action.type) {
        case "REQUEST_ADD_LEVELFOUR":
            return { ...state, isAddingLevelFour: true };
        case "SUCCESS_ADD_LEVELFOUR":
            return { ...state, levelFourList: action.payload, isAddingLevelFour: false };
        case "ERROR_ADD_LEVELFOUR":
            return { ...state };


        case "REQUEST_GET_LEVELFOUR_DROPDOWN":
            return { ...state, isFetchingLevelFourDropDown: true };
        case "SUCCESS_GET_LEVELFOUR_DROPDOWN":
            return { ...state, levelFourDropDownList: action.payload.data, isFetchingLevelFourDropDown: false };
        case "ERROR_GET_LEVELFOUR_DROPDOWN":
            return { ...state, isFetchingLevelFourDropDown: false };


        case "REQUEST_GET_ACCOUNT_TYPE":
            return { ...state, isFetchingAccountType: true };
        case "SUCCESS_GET_ACCOUNT_TYPE":
            return { ...state, accountTypeList: action.payload, isFetchingAccountType: false };
        case "ERROR_GET_ACCOUNT_TYPE":
            return { ...state, isFetchingAccountType: false };


        case "REQUEST_UPLOAD_LEVELFFOUR_FILE":
            return { ...state, isUploadingLevelFour: true };
        case "SUCCESS_UPLOAD_LEVELFFOUR_FILE":
            return { ...state, uploadlevelFour: action.payload, isUploadingLevelFour: false };
        case "ERROR_UPLOAD_LEVELFOUR_FILE":
            return { ...state };


        case "REQUEST_LEVELFOUR_VIEW":
            return { ...state, isFetchingLevelFourViewData: true };
        case "SUCCESS_LEVELFOUR_VIEW":
            return { ...state, levelFourViewData: action.payload, isFetchingLevelFourViewData: false };
        case "ERROR_LEVELFOUR_VIEW":
            return { ...state, isFetchingLevelFourViewData: false };


        default:
            return state;
    }
};
export default LevelFourReducer;